import { Box, ButtonGroup, IconButton, Paper, Typography } from "@mui/material";
import { CustomTabPanel } from "../close_daily"
import Grid from "@mui/material/Grid2";
import DownloadIcon from '@mui/icons-material/Download';
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { convertArrayOfObjectsToCSV } from "src/shared/util/functions";

const columns: GridColDef[] = [
    // { field: 'id', headerName: 'ID', flex: 1 },
    { field: 'Locacion', headerName: 'Locacion', flex: 1 },
    { field: 'requeridoPor', headerName: 'requerido Por', flex: 1 },
    { field: 'Carta', headerName: 'Carta', flex: 1 },
    { field: 'Nivel', headerName: 'Nivel', flex: 1 },
    { field: 'Reespaceo', headerName: 'Reespaceo', flex: 1 },
    { field: 'Prueba Presión', headerName: 'Prueba Presión', flex: 1 },
    { field: 'Prueba de Válvula', headerName: 'Prueba de Válvula', flex: 1 },
];


export const PendingRequirementsComponent = ({ value, requirements }: { value: any, requirements: any[] }) => {

    const paginationModel = { page: 0, pageSize: 10 };

    const [data, setData] = useState<any[]>([])

    useEffect(() => {

        const requiremtsWithId:any[] = []

        requirements?.forEach((req: any, i:number) => {
            requiremtsWithId.push({
                id: i,
                ...req })
        })

        setData(requiremtsWithId)

    }, [requirements])
    

  const handleDownloadCSV = () => {
    try {
      if (requirements.length > 0) {
        const csv = convertArrayOfObjectsToCSV(requirements);
        const utf8Bom = "\uFEFF"; // UTF-8 BOM
        const csvWithBom = utf8Bom + csv;
        const blob = new Blob([csvWithBom], { type: "text/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.setAttribute("hidden", "");
        a.setAttribute("href", url);
        const currentTime = new Date().toISOString().replace(/[:.]/g, "-");
        a.setAttribute("download", `requerimientos_${currentTime}.csv`);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    } catch (error) {
      console.log({ error });
    }
  };

    return (
        <CustomTabPanel value={value} index={1}>
            {/* Buttons */}
            {/* Buttons Left */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3, }}>
                <IconButton
                    onClick={handleDownloadCSV}
                    sx={{
                        backgroundColor: "lightgrey",
                        color: "#fff",
                        "&:hover": {
                            backgroundColor: "#03365e",
                        },
                        ml: 2,
                    }}
                >
                    <DownloadIcon />
                </IconButton>
            </Box>
            <Paper sx={{ height: '55vh', width: '100%' }}>
                <DataGrid
                    rows={data}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[10, 20, 50, 100]}
                    checkboxSelection={false}
                    sx={{ border: 0 }}
                />
            </Paper>
        </CustomTabPanel>
    )
}